
/* eslint-disable */
import { mapMutations, mapGetters } from "vuex";
import configVars from "@/config/config_vars";

import socket from '@/plugins/socket.io.js'
import { v4 as uuidv4 } from 'uuid';
import spotify from '@/api/spotify';
import scroll from "@/util/scroll";
import spotifyFunctions from "@/api/spotify"

let appBaseUrl = configVars.appBaseUrl;

export default {
  name: "FollowOnSpotifyModal",
  components: {},
  computed: mapGetters({
    user: "user/user",
    isAutenticated: "user/isAutenticated",
    imgSrc: "user/imgSrc",
    follow: "follow",
    spotifyToken: "user/spotifyToken",
    loginOnPageReload: "loginOnPageReload",
  }),
  data() {
    return {
      w: null,
      showOnboarding: true,
      showFollowingArtist: false,
      spotifyUser: {
        firstName: "",
        lastName: "",
        email: '',
        password: '',
        spotifyId: '',
        images: [],
        imgSrc: '',
        //bot-integration
        senderId: '',
        tipo: "spotify"

      },
      senderId: null


    };
  },
  props: {
    performer: {
      senderId: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      imageUrl: {
        type: String,
        default: ''
      }
    },

  },

  mounted() {
    document.addEventListener("keydown", e => {
      if (e.keyCode == 27) {
        this.close();
      }
    });
    this.$nextTick(async () => {

      scroll.blockScroll(true);
      if (this.follow === true && this.isAutenticated && this.spotifyToken) {
        this.showOnboarding = false
        this.showFollowingArtist = true
      } else {
        this.showOnboarding = true
        this.showFollowingArtist = false

      }
    })
  },
  watch: {},
  methods: {
    loginWithSpotifyRedirect() {
      spotifyFunctions.loginWithSpotifyRedirect(this,
        `${this.$config.APP_FRONT_URL}/book/${this.performer.slug}?performerToSave=${this.performer.id}&msn=true`)
    },
    dialogClick() {
      this.dialogMessage.model = true;
    },
    close() {
      scroll.blockScroll(false);
      this.$emit("close");

      /*this.showOnboarding = true
      this.showFollowingArtist = false*/


    },
    open() {

      this.$emit("open")
    },


    spotifyAuth(spotifyAuth) {

      let spotifySessionId = uuidv4()

      let width = 450
      let height = 730
      let left = window.innerWidth / 2 - width / 2
      let top = window.innerHeight / 2 - height / 2


      this.w = window.open(
        `${appBaseUrl}sp/spotify_authorization?spotifySessionId=${spotifySessionId}`,
        `Spotify`,
        `menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=${width}, height= ${height}, top=${top}, left=${left}`
      );


      socket.emit('spotifyToken', {}, (message) => {

      })
      //this.close()

      socket.on('spotifyToken', (message) => {

        this.w.close()
        //if(message.spotifySessionId === spotifySessionId){
        spotifyAuth(message)
        //}


      })




    },

    spotifyLogin() {
      this.spotifyAuth(async message => {
        this.w.close()



        this.showOnboarding = false
        this.showFollowingArtist = true
        //this.player.getOAuthToken =  cb => { cb(this.spotifyToken); }

        /*this.player = new Spotify.Player({
          name: 'Web Playback SDK Quick Start Player',
          getOAuthToken: cb => { cb(this.spotifyToken); }
        });*/


        let userData = null
        try {
          userData = await spotify.getMe(message.access_token)


        } catch (error) {

        }

        this.showOnboarding = false
        this.showFollowingArtist = true


        if (userData) {


          this.spotifyUser = userData.data.user


          let dataForSave = {
            firstName: this.spotifyUser.display_name,
            lastName: "",
            email: this.spotifyUser.email,
            password: this.spotifyUser.email,
            spotifyId: this.spotifyUser.spotifyId,
            imgSrc: this.spotifyUser.images[0].url,
            recenty_played: [],
            following: [],
            //bot-integration
            senderId: this.senderId,
            tipo: "spotify"

          }

          this.spotifyLoginSecondStep(dataForSave)

        } else {

        }


        //Setea en la cuenta de spotify del usuario a el artista
        try {
          let response = await spotify.meFollowing(this.performer.name, message.access_token)
          this.$store.commit("user/spotifyToken", message.access_token)
        } catch (error) {


        }

      })
    },
    /**
     *
     *
     *
     * =======================
     * spotifyLoginSecondStep
     * =======================
     */
    async spotifyLoginSecondStep(dataForSave) {



      try {
        let userSignUpData = await this.$store.dispatch("user/signup", dataForSave)

      } catch (error) {

      }

      if (!this.user || this.isAutenticated == false) {

        return
      }



      let performerForSave = {
        performer_id: this.performer.id,
        name: this.performer.name,
        images: [],
        popularity_score: this.performer.popularity_score,
        category_id: this.performer.category_id, // this.performer.category.id,
        category_name: this.performer.category_name, //this.performer.category.name,
        activado: true
      };
      let datos = {
        performers: [performerForSave],
        category_id: 54 //categoría para los conciertos
      };



      await this.$store.dispatch("user/setPerformersToSave", datos);

      try {
        let setPerformerResponse = await this.$store.dispatch("user/setUserPerformers", datos)


      } catch (error) {

      }

      await this.$store.dispatch("user/updateUser");

      this.$store.dispatch("user/setIsFavorite", true);

      this.$store.commit("storeFollow", true);




      if (this.user._id) {
        try {
          let spotifySaveMyArtistsResponse = await spotify.saveMyArtists(this.user._id, this.spotifyToken)

        } catch (error) {

        }
      } else {


      }


      await this.$store.dispatch("user/updateUser");








    }




  }
};
